import React from 'react';
import cn from 'classnames';
import styles from '../index.module.scss';

interface SubjectPickerBatchFooterProps {
  /** 由主体库传入的确认文案，当前使用“添加到主体”。 */
  confirmLabel: string;
  /** 已扣除主体草稿占用数量的本次可选上限。 */
  maxSelectableCount: number;
  /** 将当前选中资源交回主体创建弹窗。 */
  onConfirm: () => void;
  /** 当前弹窗批量模式下已经选中的资源数量。 */
  selectedCount: number;
  /** 两类弹窗仅外边距不同，交互与计数保持一致。 */
  variant: 'history' | 'assetLibrary';
}

/** 主体库资源选择器专属批量底栏，统一历史记录与资产库的计数和确认操作。 */
export default function SubjectPickerBatchFooter({
  confirmLabel,
  maxSelectableCount,
  onConfirm,
  selectedCount,
  variant,
}: SubjectPickerBatchFooterProps): React.ReactElement {
  return (
    <div
      className={cn(styles.subjectPickerBatchFooter, {
        [styles.subjectPickerHistoryBatchFooter]: variant === 'history',
        [styles.subjectPickerAssetLibraryBatchFooter]: variant === 'assetLibrary',
      })}
      role="toolbar"
      aria-label="主体素材批量选择"
    >
      <span className={styles.subjectPickerBatchCount} aria-live="polite">
        {`已选 ${selectedCount}/${maxSelectableCount} 条`}
      </span>
      <button
        type="button"
        className={styles.subjectPickerBatchConfirm}
        disabled={selectedCount === 0}
        onClick={onConfirm}
      >
        {confirmLabel}
      </button>
    </div>
  );
}
